import { ControlOutlined } from '@ant-design/icons';
import { t } from 'i18next';
import React, {
  type ForwardRefExoticComponent,
  type RefAttributes,
} from 'react';

import styles from './components.module.less';

import type { AntdIconProps } from '@ant-design/icons/es/components/AntdIcon';

type TPageTitleProps = {
  isEdit: boolean;
  name: string;
  Icon?: ForwardRefExoticComponent<
    Omit<AntdIconProps, 'ref'> & RefAttributes<HTMLSpanElement>
  >;
};

export const EditPageTitle = ({
  isEdit,
  name,
  Icon = ControlOutlined,
}: TPageTitleProps): React.ReactNode => (
  <div className={styles.pageTitle}>
    <Icon />
    {isEdit
      ? t('actions.edit', { type: name })
      : t('actions.add', { type: name })}
  </div>
);
